module.exports = "<nav>\r\n    <ul>\r\n        <li *ngFor=\"let subitem of subitems\">\r\n            <fw-submenu-item [subitem]=\"subitem\">\r\n            </fw-submenu-item>\r\n        </li>\r\n    </ul>\r\n</nav>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/menu/submenu.component.html
// module id = 2132
// module chunks = 1